import { render } from "./aseguradoras.vue?vue&type=template&id=8f9d084e&scoped=true"
import script from "./aseguradoras.vue?vue&type=script&lang=js"
export * from "./aseguradoras.vue?vue&type=script&lang=js"

import "./aseguradoras.vue?vue&type=style&index=0&id=8f9d084e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9d084e"]])

export default __exports__